<form
    class="rounded-lg p-1 flex flex-col justify-start items-stretch transition-colors"
    [formGroup]="attributeForm"
    [ngClass]="{
        'bg-error !bg-opacity-40': editMode && markedForDelete,
        'bg-success !bg-opacity-20': editMode && markedForUpsert && !markedForDelete
    }"
>
    <div class="w-full flex flex-row items-end gap-2">
        <div class="w-full grid grid-cols-5 gap-2">
            <div [ngClass]="{ 'col-span-2': isStringAttribute, 'col-span-3': !isStringAttribute }" *ngIf="hideTitleAndValueType"></div>
            <div class="form-control" [ngClass]="{ 'col-span-2': !isStringAttribute }" *ngIf="!hideTitleAndValueType">
                <label class="label py-0">
                    <span class="label-text" i18n>Attribute name</span>
                </label>
                <input type="text" class="input input-bordered w-full" formControlName="attributeName" />
            </div>

            <div class="form-control" *ngIf="!hideTitleAndValueType">
                <label class="label py-0">
                    <span class="label-text" i18n>Value type</span>
                </label>
                <select class="w-full select select-bordered" formControlName="attributeValueType">
                    <option *ngFor="let type of attributeValueTypes" [value]="type">
                        {{ getValueTypeDescription(type) }}
                    </option>
                </select>
            </div>

            <div class="col-span-2 form-control">
                <label class="label py-0" *ngIf="!hideTitleAndValueType">
                    <span class="label-text" i18n>Attribute value(s)</span>
                </label>

                <div class="flex-1 flex flex-row items-center gap-2">
                    <div
                        class="h-6 w-6 bg-accent flex items-center justify-center rounded-full"
                        [matTooltip]="isOverride ? overridesOtherAttributeTooltip : parentIdIsThisParentIdTooltip"
                        matTooltipClass="bg-iota-tooltip-bg whitespace-pre-line"
                        *ngIf="showEntitySpecificTooltip"
                    >
                        <iota-icon class="text-white" icon="adjustments-horizontal"></iota-icon>
                    </div>
                    <input type="text" class="flex-1 input input-bordered" formControlName="attributeValue" />
                </div>
            </div>
            <div class="form-control w-full" *ngIf="attributeForm.get('attributeValueType').value === 'STRING'">
                <label class="label py-0" *ngIf="!hideTitleAndValueType">
                    <span class="label-text" i18n>Language</span>
                </label>
                <select class="select select-bordered" formControlName="attributeLocale">
                    <option *ngFor="let localeOption of possibleLocales" [ngValue]="localeOption">
                        {{ localeOption }}
                    </option>
                </select>
            </div>
        </div>

        <div class="flex flex-row items-center gap-2">
            <div class="tooltip" i18n-data-tip data-tip="reset to default" *ngIf="!!previousAttribute?.attributeId">
                <button class="btn btn-accent" [disabled]="!editMode || !markedForUpsert || markedForDelete" (click)="resetAttribute()">
                    <iota-icon icon="arrow-uturn-left" size="1.2"></iota-icon>
                </button>
            </div>

            <div
                class="tooltip"
                data-tip="Delete"
                *ngIf="deletable && !markedForDelete && (!previousAttribute?.attributeId || parentId === previousAttribute?.parentSkId)"
            >
                <button class="btn btn-error" (click)="markForDelete()" [disabled]="!editMode">
                    <iota-icon icon="trash" size="1.2"></iota-icon>
                </button>
            </div>
            <div class="tooltip" data-tip="Wiederherstellen" *ngIf="markedForDelete">
                <button class="btn btn-primary" (click)="undoMarkForDelete()">
                    <iota-icon icon="arrow-path" size="1.2"></iota-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="grid grid-cols-5 gap-2">
        <div [ngClass]="{ 'col-span-2': isStringAttribute, 'col-span-3': !isStringAttribute }">
            <span class="text-error" *ngIf="attributeForm.get('attributeName').invalid" i18n>Attribute name is mandatory</span>
            <span class="text-error" *ngIf="nameAlreadyUsed" i18n>This attribute name is already in use</span>
        </div>
        <div class="col-span-2">
            <span class="text-error" *ngIf="attributeForm.get('attributeValue').hasError('required')" i18n>The value cannot be empty </span>
            <span class="text-error" *ngIf="attributeForm.get('attributeValue').hasError('parsingFailed')" i18n
                >Unable to parse the values</span
            >
        </div>
    </div>
</form>
